module.exports = __webpack_public_path__ + "img/Zone history green.svg";